<template>
  <section :class="$style.root">
    <slot />
  </section>
</template>

<script>
import Velocity from 'velocity-animate';

import breakpoints from '../config/index';

export default {
  name: 'BackgroundAnimation',
  data() {
    return {
      $dots: null,
      $container: null,

      dotsCount: 0,
      dotsHtml: '',
      dotsColor: '#f75050',

      containerHeight: 0,
      containerWidth: 0,
      translateZMin: -725,
      translateZMax: 600,
      containerAnimationMap: {
        perspective: [50, 215],
      },
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize, { passive: true });
    this.initialize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.destroy();
  },
  methods: {
    randomNumb(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    dotCreate() {
      switch (true) {
        case window.innerWidth > breakpoints.desktop:
          this.dotsCount = 120;
          break;
        case window.innerWidth <= breakpoints.desktop &&
          window.innerWidth > breakpoints.phone:
          this.dotsCount = 80;
          break;
        case window.innerWidth <= breakpoints.phone:
          this.dotsCount = 40;
          break;
        default:
          this.dotsCount = 0;
      }

      this.dotsHtml = '';
      for (let i = 0; i < this.dotsCount; i++) {
        this.dotsHtml += `<div class=${this.$style.dot}></div>`;
      }
      this.$dots = $(this.dotsHtml);
    },
    containerCreate() {
      this.$container = $('<div />').addClass(this.$style.dotsContainer);
      this.$container.appendTo($(`.${this.$style.root}`));
    },
    dotsSetup() {
      this.$dots.css('backgroundColor', this.dotsColor);
      this.$dots.appendTo(this.$container);
    },
    containerSetup() {
      this.containerWidth = this.$container.outerWidth();
      this.containerHeight = this.$container.outerHeight();

      this.$container.css(
        'perspective-origin',
        `${this.containerWidth / 2}px ${this.containerHeight * 0.45}px`,
      );
    },
    dotsAnimation() {
      Velocity(
        this.$dots,
        {
          translateX: [
            () =>
              `+=${this.randomNumb(
                -this.containerWidth / 2.5,
                this.containerWidth / 2.5,
              )}`,
            () => this.randomNumb(0, this.containerWidth),
          ],
          translateY: [
            () =>
              `+=${this.randomNumb(
                -this.containerHeight / 2.75,
                this.containerHeight / 2.75,
              )}`,
            () => this.randomNumb(0, this.containerHeight),
          ],
          translateZ: [
            () =>
              `+=${this.randomNumb(this.translateZMin, this.translateZMax)}`,
            () => this.randomNumb(this.translateZMin, this.translateZMax),
          ],
          opacity: [() => Math.random(), () => Math.random() + 0.1],
        },
        { duration: 6000, loop: true },
      );
    },
    containerAnimation() {
      Velocity(this.$container, this.containerAnimationMap, {
        duration: 800,
        loop: true,
        delay: 3250,
      });
    },
    initialize() {
      this.containerCreate();
      this.dotCreate();

      this.containerSetup();
      this.dotsSetup();

      this.containerAnimation();
      this.dotsAnimation();
    },
    destroy() {
      Velocity(this.$container, 'stop');
      Velocity(this.$dots, 'stop');
      this.$container.remove();
    },
    reInitialize() {
      this.destroy();
      this.initialize();
    },
    handleResize() {
      this.reInitialize();
    },
  },
};
</script>

<style lang="scss" module>
.root {
  position: relative;
}

.dot {
  position: absolute;
  width: 30px;
  height: 30px;
  border-radius: 30px;
}

.dotsContainer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  perspective: 215px;
}
</style>



// WEBPACK FOOTER //
// src/components/BackgroundAnimation.vue